import { formatScalePct } from "../../lib/board/boardViewport";

type Props = {
  scale: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  /** Подогнать камеру под весь контент (или выделение). */
  onFitContent?: () => void;
  canFitContent?: boolean;
  canZoomIn?: boolean;
  canZoomOut?: boolean;
  /** Показать / скрыть мини-карту. */
  minimapVisible?: boolean;
  onToggleMinimap?: () => void;
};

/**
 * Панель зума в углу доски: − / % / + / вместить всё / карта.
 */
export function BoardZoomControls({
  scale,
  onZoomIn,
  onZoomOut,
  onReset,
  onFitContent,
  canFitContent = true,
  canZoomIn = true,
  canZoomOut = true,
  minimapVisible,
  onToggleMinimap,
}: Props) {
  return (
    <div className="wb-zoom-controls" role="group" aria-label="Масштаб доски">
      <button
        type="button"
        className="wb-zoom-btn"
        onClick={onZoomOut}
        disabled={!canZoomOut}
        title="Уменьшить"
        aria-label="Уменьшить масштаб"
      >
        −
      </button>
      <button
        type="button"
        className="wb-zoom-readout"
        onClick={onReset}
        title="Сбросить масштаб 100% и центрировать"
        aria-label={`Масштаб ${formatScalePct(scale)}, сбросить`}
      >
        {formatScalePct(scale)}
      </button>
      <button
        type="button"
        className="wb-zoom-btn"
        onClick={onZoomIn}
        disabled={!canZoomIn}
        title="Увеличить"
        aria-label="Увеличить масштаб"
      >
        +
      </button>
      {onFitContent ? (
        <button
          type="button"
          className="wb-zoom-btn wb-zoom-btn--fit"
          onClick={onFitContent}
          disabled={!canFitContent}
          title="Показать всё на доске"
          aria-label="Показать всё содержимое доски"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden>
            <path
              fill="currentColor"
              d="M2 2h4v1.5H3.5V6H2V2zm8 0h4v4h-1.5V3.5H10V2zM2 10h1.5v2.5H6V14H2v-4zm8 4v-1.5h2.5V10H14v4h-4z"
            />
            <rect x="5" y="5" width="6" height="6" rx="1" fill="none" stroke="currentColor" strokeWidth="1.25" />
          </svg>
        </button>
      ) : null}
      {onToggleMinimap ? (
        <button
          type="button"
          className={`wb-zoom-btn wb-zoom-btn--map${minimapVisible ? " is-active" : ""}`}
          onClick={onToggleMinimap}
          title={minimapVisible ? "Скрыть мини-карту" : "Показать мини-карту"}
          aria-label={minimapVisible ? "Скрыть мини-карту" : "Показать мини-карту"}
          aria-pressed={Boolean(minimapVisible)}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden>
            <path
              fill="currentColor"
              d="M1.5 2.75 5.2 1.5l2.8 1.1L12.8 1.5 14.5 2.8v11.45l-1.7-1.3-4.8 1.55-2.8-1.1L1.5 14.7V2.75zm1.25 1.05v8.9l2.2-.9V2.95l-2.2.85zm3.45-.75v8.85l2.35.95V4.05L6.2 3.05zm3.6 1.15v8.9l3.45-1.1V3.2L9.8 4.2z"
            />
          </svg>
        </button>
      ) : null}
    </div>
  );
}
